/**
 * MenuSeparator component for visual separation between menu items
 *
 * @example
 * ```tsx
 * <Menu>
 *   <MenuItem>Edit</MenuItem>
 *   <MenuSeparator />
 *   <MenuItem destructive>Delete</MenuItem>
 * </Menu>
 * ```
 */
export function MenuSeparator() {
  return <div className="my-pb-1 border-t border-uiv2-border-secondary" role="separator" />;
}
